module.exports = __webpack_public_path__ + "assets/img/poster-2.b97f8fd0.png";